import { render, staticRenderFns } from "./autocompletelist.vue?vue&type=template&id=5f45fc57&scoped=true&"
import script from "./autocompletelist.vue?vue&type=script&lang=js&"
export * from "./autocompletelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f45fc57",
  null
  
)

export default component.exports